import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import type { PaginatedResponse, User } from "./types";

export function useUsers(params?: Record<string, string>) {
  return useQuery<PaginatedResponse<User>>({
    queryKey: ["users", params],
    queryFn: async () => {
      const { data } = await client.get("/users/", { params });
      return data;
    },
  });
}

export function useUserDetail(userId: string) {
  return useQuery<User>({
    queryKey: ["users", userId],
    queryFn: async () => {
      const { data } = await client.get(`/users/${userId}/`);
      return data;
    },
    enabled: !!userId,
  });
}

export function useCreateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: Record<string, unknown>) => {
      const { data } = await client.post("/users/", payload);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["users"] }),
  });
}

export function useUpdateUser(userId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: Record<string, unknown>) => {
      const { data } = await client.patch(`/users/${userId}/`, payload);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["users"] }),
  });
}
